import { PredicateNodeBinaryOperators } from '../predicate';

export enum WorkflowStateEnum {
  Draft,
  Published
}
export enum WorkflowStateTypeEnum {
  Beginning = 1,
  Middle,
  End
}

export enum WorkflowStateAssignmentTypeEnum {
  None = 0,
  PermissionGroup,
  OrgChart,
  Originator
}

export enum WorkflowTransitionActionTypeEnum {
  SendEmail = 1,
  GrantAccess = 2
}

export enum TransitionActionRecipientTypeEnum {
  Email = 1,
  Owner
}

export enum TransitionActionRecipientSubTypeEnum {
  Direct = 1,
  CC,
  BCC
}

export const TransitionNodeBinaryOperators = PredicateNodeBinaryOperators;

// Create a type from the values of the TransitionNodeBinaryOperators.
// https://dev.to/egorovsa/how-to-extend-enum-in-typescript-cj4
export type TransitionNodeBinaryOperators = typeof TransitionNodeBinaryOperators[keyof typeof TransitionNodeBinaryOperators];

export enum TransitionNodeOperandSubtype {
  Constant,
  Variable,
  OwnerGroup,
  Threshold,
  AssigneeGroup
}
